// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table .warning-row {\r\n  background: oldlace;\n}\n.el-table .success-row {\r\n  background: #f0f9eb;\n}\n.el-table .error-row {\r\n  background: #fde2e2;\n}\n.el-table .primary-row {\r\n  background: #8cc5ff;\n}\r\n", ""]);
// Exports
module.exports = exports;
